
export const CircleExclamation = () => {
    return (
        <svg aria-hidden width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7394_17393)">
                <g clipPath="url(#clip1_7394_17393)">
                    <path
                        d="M7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14ZM7 3.5C7.36367 3.5 7.65625 3.79258 7.65625 4.15625V7.21875C7.65625 7.58242 7.36367 7.875 7 7.875C6.63633 7.875 6.34375 7.58242 6.34375 7.21875V4.15625C6.34375 3.79258 6.63633 3.5 7 3.5ZM7.875 9.625C7.875 10.109 7.48398 10.5 7 10.5C6.51602 10.5 6.125 10.109 6.125 9.625C6.125 9.14102 6.51602 8.75 7 8.75C7.48398 8.75 7.875 9.14102 7.875 9.625Z"
                        fill="#00807B"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_7394_17393">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
                <clipPath id="clip1_7394_17393">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
